/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbInventoryAttribute {
    getFixupPrototypeFunction() { return ServiceNowCmdbInventoryAttribute.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbInventoryAttribute>): ServiceNowCmdbInventoryAttribute {
        let obj = Object.assign(new ServiceNowCmdbInventoryAttribute(), model);
        ServiceNowCmdbInventoryAttribute.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbInventoryAttribute>): ServiceNowCmdbInventoryAttribute {
        if (!model) return null;
        return ServiceNowCmdbInventoryAttribute.newInstance(<ServiceNowCmdbInventoryAttribute> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbInventoryAttribute) {
        if (!obj) return;

        models.ServiceNowCmdbInventoryAttribute.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbInventoryAttribute): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbInventoryAttribute.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Identifier for the Inventory attribute
     */
    attribute_id: string;

    /**
     * Display Name of the Inventory attribute
     */
    display_name: string;

}
